/* eslint-disable max-classes-per-file */
import { assign } from "lodash";
import { VKForkalkylTradslagDTO } from "./tradslag-models";

export class VKKalkylmallTradslagDTO {
    andel?: number;
    medelstam?: number;
    timmerandel?: number;
    massavedandel?: number;
    granmassavedsandel?: number;
    branslevedandel?: number;
    varavGrovtimmer?: number; // Samma sak som stamblock
    varavKlentimmer?: number;
    tradslag: VKForkalkylTradslagDTO;
}

export class VKSnabbkalkylmallDTO {
    id?: number;
    namn: string;
    kalkylmallTradslag?: VKKalkylmallTradslagDTO[];
}

export class VKSnabbkalkylmall extends VKSnabbkalkylmallDTO {
    kalkylmallTradslag: VKKalkylmallTradslagDTO[] = [];

    constructor(dto?: VKSnabbkalkylmallDTO) {
        super();
        if(dto) {
            assign(this, dto);
        }
    }

}
